import { Link } from 'react-router-dom';
import { formatPlayCount, getHotVideos, typeNameMap } from '@/utils/videos';

export default function RankingSidebar() {
  const ranking = getHotVideos(8);

  return (
    <aside className="flex flex-col gap-5">
      <div className="rounded-lg bg-background-100 border border-background-200/70 p-5">
        <div className="flex items-center gap-2 mb-4">
          <span className="w-8 h-8 rounded-md bg-accent-500/15 flex items-center justify-center text-accent-400">
            <i className="ri-fire-line text-lg" />
          </span>
          <h3 className="font-heading text-base font-bold text-foreground-950">热门播放榜</h3>
        </div>
        <ol className="flex flex-col gap-1">
          {ranking.map((video, i) => (
            <li key={video.id}>
              <Link
                to={`/detail/${video.id}`}
                className="flex items-center gap-3 py-2 group"
              >
                <span
                  className={`w-6 h-6 shrink-0 rounded-md flex items-center justify-center text-xs font-bold ${
                    i < 3 ? 'bg-primary-500 text-background-950' : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {i + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="text-sm text-foreground-900 line-clamp-1 group-hover:text-primary-400 transition-colors">
                    {video.title}
                  </p>
                  <p className="text-[11px] text-foreground-500">
                    {typeNameMap[video.type]} · {formatPlayCount(video.playCount)}
                  </p>
                </div>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg bg-background-100 border border-background-200/70 p-5">
        <div className="flex items-center gap-2 mb-4">
          <span className="w-8 h-8 rounded-md bg-secondary-500/15 flex items-center justify-center text-secondary-400">
            <i className="ri-sparkling-2-line text-lg" />
          </span>
          <h3 className="font-heading text-base font-bold text-foreground-950">平台亮点</h3>
        </div>
        <ul className="flex flex-col gap-3 text-sm text-foreground-700">
          <li className="flex items-start gap-2">
            <i className="ri-checkbox-circle-fill text-primary-400 mt-0.5" />
            <span>电影、电视剧、综艺多类别一站式浏览</span>
          </li>
          <li className="flex items-start gap-2">
            <i className="ri-checkbox-circle-fill text-primary-400 mt-0.5" />
            <span>支持按地区、年份、热度快速筛选</span>
          </li>
          <li className="flex items-start gap-2">
            <i className="ri-checkbox-circle-fill text-primary-400 mt-0.5" />
            <span>关键词搜索，快速定位想看的作品</span>
          </li>
          <li className="flex items-start gap-2">
            <i className="ri-checkbox-circle-fill text-primary-400 mt-0.5" />
            <span>收藏喜欢的视频，随时回看更省心</span>
          </li>
        </ul>
      </div>
    </aside>
  );
}